import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import '../../index.css'
import Section8Image from '../../assets/images/Section8Image1.png'
import LandingPageModal from 'components/Modal'
import { Link } from 'react-router'

const Section8 = () => {
  const [, setIsMobileMenuOpen] = useState(false)
  const [modalData, setModalData] = useState({ isOpen: false, type: '' })

  // Open modal with specific type
  const handleModalOpen = (type) => {
    setModalData({ isOpen: true, type })
    setIsMobileMenuOpen(false) // Close mobile menu when opening modal
  }

  // Close modal
  const handleModalClose = () => {
    setModalData({ isOpen: false, type: '' })
  }

  const { ref: Section8Ref, inView: Section8InView } = useInView({ triggerOnce: false })

  const fadeInUpVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.9 } },
  }

  return (
    <motion.section
      className="Section8"
      ref={Section8Ref}
      variants={fadeInUpVariant}
      initial="hidden"
      animate={Section8InView ? 'visible' : 'hidden'}
    >
      <div className="Section8-container">
        <div className="Section8-content">
          <motion.h2
            className="Section8-title text-[48px]"
            variants={fadeInUpVariant}
            transition={{ delay: 0.2 }}
          >
            Join the Blockchain Learning Revolution
          </motion.h2>
          <motion.p
            className="Section8-description"
            variants={fadeInUpVariant}
            transition={{ delay: 0.3 }}
          >
            Sign up today to unlock your potential in blockchain and cryptocurrency education.
          </motion.p>
          <Link to="/student/register">
            <motion.button
              onClick={() => handleModalOpen('student')}
              className="cta-button"
              variants={fadeInUpVariant}
              transition={{ delay: 0.4 }}
            >
              Become a Student
            </motion.button>
          </Link>
        </div>
        <motion.div
          className="Section8-image-container"
          variants={fadeInUpVariant}
          transition={{ delay: 0.5 }}
        >
          <img src={Section8Image} alt="Student learning blockchain" className="Section8-image" />
        </motion.div>
      </div>

      {modalData.isOpen && <LandingPageModal onClose={handleModalClose} type={modalData.type} />}
    </motion.section>
  )
}

export default Section8
